__turbopack_context__.v({
  "centerContainer": "cardImage-module-scss-module__myf75G__centerContainer",
  "fade-in": "cardImage-module-scss-module__myf75G__fade-in",
  "flipperButton": "cardImage-module-scss-module__myf75G__flipperButton",
});
